import _extends from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["variant", "intent", "size", "leftIcon", "rightIcon", "loading", "iconOnly", "className", "type", "disabled", "children"];
import React from "react";
var __jsx = React.createElement;
import { Button as MantineButton } from "@mantine/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/pro-regular-svg-icons";
import { BUTTON_BASE, BUTTON_GHOST, BUTTON_ICON_ONLY_SIZE, BUTTON_PRIMARY, BUTTON_SECONDARY, BUTTON_SIZE } from "./button-classes";
/** SDS button — Mantine Button styled with SDS sizing, variants, intents, icons and loading. */
export function Button(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "primary" : _ref$variant,
    intent = _ref.intent,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "md" : _ref$size,
    leftIcon = _ref.leftIcon,
    rightIcon = _ref.rightIcon,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$iconOnly = _ref.iconOnly,
    iconOnly = _ref$iconOnly === void 0 ? false : _ref$iconOnly,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? "button" : _ref$type,
    disabled = _ref.disabled,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var resolvedIntent = intent !== null && intent !== void 0 ? intent : variant === "primary" ? "brand" : "base";
  var colorClass = variant === "secondary" ? BUTTON_SECONDARY : variant === "ghost" ? BUTTON_GHOST[resolvedIntent] : BUTTON_PRIMARY[resolvedIntent];
  var sizeClass = iconOnly ? BUTTON_ICON_ONLY_SIZE[size] : BUTTON_SIZE[size];
  return /*#__PURE__*/React.createElement(MantineButton, _extends({
    unstyled: true,
    type: type,
    disabled: disabled || loading,
    className: "".concat(BUTTON_BASE, " ").concat(sizeClass, " ").concat(colorClass, " ").concat(className),
    classNames: {
      inner: "inline-flex w-full items-center justify-center",
      label: "inline-flex items-center gap-2"
    }
  }, props), loading ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faSpinner,
    className: "h-3.5 w-3.5 animate-spin"
  }) : leftIcon ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: leftIcon,
    className: "h-3.5 w-3.5"
  }) : null, children, rightIcon && !loading ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: rightIcon,
    className: "h-3.5 w-3.5"
  }) : null);
}